export default {
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    delete: 'Удалить',
    edit: 'Редактировать',
    view: 'Просмотр',
    back: 'Назад',
    close: 'Закрыть',
    add: 'Добавить',
    send: 'Отправить',
    sending: 'Отправка...',
    saving: 'Сохранение...',
    loading: 'Загрузка...',
    search: 'Поиск',
    update: 'Обновить',
    create: 'Создать',
    creating: 'Создание...',
    transfer: 'Перенести',
    approve: 'Одобрить',
    reject: 'Отклонить',
    ok: 'Понятно',
    name: 'Имя',
    username: 'Имя пользователя',
    password: 'Пароль',
    email: 'Эл. почта',
    date: 'Дата',
    status: 'Статус',
    type: 'Тип',
    quantity: 'Количество',
    description: 'Описание',
    project: 'Проект',
    task: 'Задача',
    logout: 'Выйти',
    notifications: 'Уведомления',
    settings: 'Настройки',
    draft: 'Черновик',
    sent: 'Отправлено',
    active: 'Активный',
    inactive: 'Неактивный',
    priority: 'Приоритет',
    language: 'Язык',
    yes: 'Да',
    no: 'Нет',
    error: 'Ошибка',
    success: 'Успех',
    warning: 'Внимание',
    required: 'Обязательно',
    optional: 'Необязательно',
    all: 'Все',
    none: 'Нет',
    upload: 'Загрузить файл',
    download: 'Скачать',
    print: 'Печать',
    actions: 'Действия',
    details: 'Подробности',
    filters: 'Фильтры',
    results: 'Результаты',
    noResults: 'Результаты не найдены',
    total: 'Итого',
    of: 'из',
    verified: 'подтверждено',
    pending: 'Ожидает',
    completed: 'Завершено',
    cancelled: 'Отменено',
  },

  auth: {
    login: 'Войти',
    loginTitle: 'Войдите в свой аккаунт',
    logout: 'Выйти',
    register: 'Зарегистрироваться',
    forgotPassword: 'Забыли пароль?',
    resetPassword: 'Сбросить пароль',
    usernameOrEmail: 'Имя пользователя или эл. почта',
    enterPassword: 'Введите пароль',
    enterUsername: 'Введите имя пользователя',
    loginError: 'Неверное имя пользователя или пароль.',
    sessionExpired: 'Сессия истекла. Пожалуйста, войдите снова.',
  },

  nav: {
    dashboard: 'Панель управления',
    overview: 'Обзор',
    documents: 'Документы',
    viewDocuments: 'Просмотр документов',
    manageProjects: 'Управление проектами',
    viewProjects: 'Просмотр проектов',
    manageUsers: 'Управление пользователями',
    viewUsers: 'Просмотр пользователей',
    manageWarehouse: 'Управление складом',
    viewWarehouse: 'Просмотр склада',
    manageMachinery: 'Управление техникой',
    viewMachinery: 'Просмотр техники',
    manageSystem: 'Управление системой',
    projects: 'Проекты',
    myProjects: 'Мои проекты',
    myTasks: 'Мои задачи',
    reports: 'Отчёты',
    drawings: 'Чертежи',
    warehouse: 'Склад',
    checkStock: 'Проверить запасы',
    requests: 'Заявки',
    requestItem: 'Запросить позицию',
    tickets: 'Заявки',
    messages: 'Сообщения',
    adminMode: 'Режим администратора',
    standardMode: 'Стандартный режим',
    analystMode: 'Режим аналитика',
    createReport: 'Создать отчёт',
    createReports: 'Строительные отчёты',
    dailyReport: 'Ежедневный строительный отчёт',
    incidentReport: 'Отчёт об инциденте',
    safetySection: 'Охрана труда',
    safetyDialog: 'Инструктаж по безопасности',
    workPermit: 'Наряд-допуск',
    occurrenceReport: 'Отчёт о происшествии',
    settingsMenu: 'Настройки',
  },

  profile: {
    editProfile: 'Редактировать профиль',
    displayName: 'Имя',
    usernameLabel: 'Имя пользователя',
    passwordLabel: 'Пароль',
    changePassword: 'Изменить пароль',
    appearance: 'Внешний вид',
    lightMode: 'Светлая тема',
    darkMode: 'Тёмная тема',
    languageLabel: 'Язык',
    cropTitle: 'Обрезать фото профиля',
    cropUse: 'Использовать эту область',
    zoom: 'Масштаб',
    currentPassword: 'Подтвердите текущий пароль',
    newPassword: 'Новый пароль',
    confirmNewPassword: 'Подтвердите новый пароль',
    emailVerified: 'подтверждено',
    emailChange: 'Изменить',
    emailSendCode: 'Отправить код',
    emailConfirm: 'Подтвердить',
    emailResend: '← Отправить код повторно',
    emailCancelChange: 'Отмена',
    emailSending: 'Отправка...',
    emailVerifying: 'Проверка...',
    emailHint: 'Код отправлен на {email}. Проверьте входящие и спам.',
    emailSuccess: 'Эл. почта {email} успешно подтверждена.',
    emailInvalidError: 'Введите действительный адрес эл. почты.',
    emailGenericError: 'Ошибка при отправке кода.',
    emailInvalidCode: 'Неверный код.',
    passwordFillAll: 'Заполните все поля для смены пароля.',
    passwordWrong: 'Текущий пароль неверен.',
    passwordMismatch: 'Подтверждение нового пароля не совпадает.',
    saveFillAll: 'Заполните имя и имя пользователя.',
    saveFinishPassword: 'Завершите или отмените смену пароля перед сохранением.',
    avatarAlt: 'профиль',
  },

  dashboard: {
    overview: 'Обзор',
    myProjects: 'Мои проекты',
    myTasks: 'Мои задачи',
    activeProjects: 'Активные проекты',
    completedTasks: 'Выполненные задачи',
    pendingTasks: 'Ожидающие задачи',
    recentActivity: 'Последняя активность',
    noProjects: 'Проекты не найдены.',
    noTasks: 'Задачи не найдены.',
    createProject: 'Создать проект',
    projectName: 'Название проекта',
    startDate: 'Дата начала',
    endDate: 'Дата окончания',
  },

  projects: {
    title: 'Проекты',
    newProject: 'Новый проект',
    projectName: 'Название проекта',
    startDate: 'Начало',
    endDate: 'Конец',
    progress: 'Прогресс',
    team: 'Команда',
    gantt: 'Календарный план',
    files: 'Файлы',
    tickets: 'Заявки',
    warehouse: 'Склад',
    dds: 'Инструктаж',
    reports: 'Отчёты',
    noProjects: 'Нет проектов.',
    deleteConfirm: 'Вы уверены, что хотите удалить этот проект?',
  },

  tasks: {
    title: 'Задачи',
    newTask: 'Новая задача',
    taskName: 'Название задачи',
    assignee: 'Ответственный',
    dependencies: 'Зависимости',
    duration: 'Продолжительность (дни)',
    startDate: 'Начало',
    endDate: 'Конец',
    progress: 'Прогресс',
    addProgress: 'Отметить прогресс',
    noTasks: 'Нет задач.',
    blocked: 'Заблокирована',
    inProgress: 'В процессе',
    done: 'Выполнено',
    deleteConfirm: 'Удалить эту задачу?',
  },

  warehouse: {
    title: 'Склад',
    stock: 'Запасы',
    requestItem: 'Запросить позицию',
    requests: 'Заявки',
    addItem: 'Добавить позицию',
    itemName: 'Наименование',
    category: 'Категория',
    unit: 'Единица',
    available: 'Доступно',
    reserved: 'Зарезервировано',
    transferItem: 'Перенести позицию',
    reportDamage: 'Сообщить о повреждении',
    provideEquipment: 'Предоставить оборудование',
    noItems: 'На складе нет позиций.',
    noRequests: 'Нет заявок.',
    approveRequest: 'Одобрить заявку',
    rejectRequest: 'Отклонить заявку',
    requestStatus: {
      pending: 'Ожидает',
      approved: 'Одобрено',
      rejected: 'Отклонено',
      delivered: 'Доставлено',
    },
  },

  safety: {
    title: 'Безопасность',
    dds: 'Инструктаж',
    ddsTitle: 'Ежедневный инструктаж по безопасности',
    newDds: 'Новый инструктаж',
    occurrences: 'Происшествия',
    permits: 'Наряды-допуски',
    createDialog: 'Создать беседу',
    createOccurrence: 'Зафиксировать происшествие',
    createPermit: 'Создать наряд-допуск',
    topic: 'Тема',
    presenter: 'Докладчик',
    attendees: 'Участники',
    date: 'Дата',
    noSafety: 'Нет записей по безопасности.',
  },

  tickets: {
    title: 'Заявки',
    newTicket: 'Новая заявка',
    subject: 'Тема',
    category: 'Категория',
    openedBy: 'Открыта',
    assignedTo: 'Назначена',
    openTickets: 'Открытые заявки',
    closedTickets: 'Закрытые заявки',
    noTickets: 'Нет заявок.',
    status: {
      open: 'Открыта',
      inProgress: 'В процессе',
      closed: 'Закрыта',
    },
  },

  users: {
    title: 'Пользователи',
    newUser: 'Новый пользователь',
    role: 'Должность',
    roles: {
      adminMaster: 'Главный администратор',
      adminObra: 'Администратор стройки',
      user: 'Пользователь',
    },
    noUsers: 'Нет пользователей.',
    deleteConfirm: 'Удалить этого пользователя?',
    manageRoles: 'Управление должностями',
    manageUsers: 'Управление пользователями',
    userList: 'Список пользователей',
  },

  system: {
    title: 'Системные настройки',
    siteName: 'Название системы',
    logo: 'Логотип',
    loginBackground: 'Фон страницы входа',
    primaryColor: 'Основной цвет',
    save: 'Сохранить настройки',
    saved: 'Настройки сохранены.',
  },

  reports: {
    title: 'Отчёты',
    daily: 'Ежедневный отчёт',
    incident: 'Отчёт об инциденте',
    noReports: 'Нет отчётов.',
    createReport: 'Создать отчёт',
    date: 'Дата',
    author: 'Автор',
    content: 'Содержание',
  },

  machinery: {
    title: 'Тяжёлая техника',
    newMachine: 'Новая техника',
    machineName: 'Название',
    model: 'Модель',
    plate: 'Номерной знак',
    status: 'Статус',
    noMachinery: 'Нет техники.',
  },

  messenger: {
    title: 'Сообщения',
    newMessage: 'Новое сообщение',
    noMessages: 'Нет сообщений.',
    typeMessage: 'Введите сообщение...',
    send: 'Отправить',
  },
}
